import store from '@/store'

export default {
  /**
   * Dispatches by default a store query command
   * and applies the next callback
   * @param {string} storeName - The name of the store
   * @param {object} queryParams - Additional query parameters to be send in the request
   * @returns {function(*, *, *): Promise<T>}
   */
  onQuery (storeName, queryParams = {}, search) {
    return function (to, from, next) {
      let searchParams = {}
      if (to.query.search) {
        for (let s of search) {
          searchParams['filters[orWhere][' + s + '][contains]'] =
            to.query.search
        }
        to.query.page = 1
      }
      store
        .dispatch(storeName + '/query', {
          ...queryParams,
          ...to.query,
          ...searchParams
        })
        .then(next)
        .catch(next)
    }
  },
  /**
   *
   * @param storeName
   * @param options
   * @returns {Function}
   */
  onGet (storeName, options = {}) {
    return function (to, from, next) {
      store
        .dispatch(storeName + '/get', { id: to.params.id, ...options })
        .then(next)
        .catch(next)
    }
  }
}



// WEBPACK FOOTER //
// ./src/guards/default.guards.js